import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { Heart } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();

  useEffect(() => {
    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      toast.error('Login failed', { description: 'Missing session_id.' });
      navigate('/login');
      return;
    }
    (async () => {
      try {
        const u = await googleLogin(sessionId);
        toast.success('Welcome!', { description: `Signed in as ${u.email}` });
        if (u.has_profile) navigate('/browse');
        else navigate('/profile/setup');
      } catch (e) {
        toast.error('Login failed', { description: e.response?.data?.detail || 'Try again.' });
        navigate('/login');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-fnl-dark">
      <div className="text-center">
        <div className="flex items-center gap-2 justify-center mb-6">
          <div className="relative">
            <span className="text-white font-bold text-3xl">F</span>
            <Heart className="absolute -top-1 -right-3 w-4 h-4 fill-fnl-pink text-fnl-pink" />
          </div>
        </div>
        <div className="w-12 h-12 border-4 border-fnl-pink border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
        <p className="text-white">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
